import React, { Component } from 'react';
import { string, bool, func } from 'prop-types';

import SearchBar from 'ggApp/shared/screens/Search/Bar';
import { addEventListener, removeEventListener } from 'ggApp/modules/inwebview_api';
import { TOGGLE_ACCOUNT_MENU } from 'ggApp/routes/_wrap/MobileWrapper/constants';

import { Wrap, Button, Cart, DesktopMenu, MobileMenu } from './styled';

class BottomContent extends Component {
    componentWillMount() {
        const { closeMenu } = this.props;

        addEventListener(TOGGLE_ACCOUNT_MENU, closeMenu);
    }

    componentWillUnmount() {
        const { closeMenu } = this.props;

        removeEventListener(TOGGLE_ACCOUNT_MENU, closeMenu);
    }

    render() {
        const {
            className,
            toggleMenu,
            shouldShowMenu,
            showMenu,
            closeMenu,
            isTransparent,
            isDesktopUser,
        } = this.props;
        return (
            <Wrap className={className} isTransparent={isTransparent}>
                <Button
                    isDesktopUser={isDesktopUser}
                    showMenu={showMenu}
                    closeMenu={closeMenu}
                    toggleMenu={toggleMenu}
                    menuIsOpen={shouldShowMenu}
                />
                {isDesktopUser ? (
                    <DesktopMenu
                        shouldShowMenu={shouldShowMenu}
                        showMenu={showMenu}
                        closeMenu={closeMenu}
                    />
                ) : (
                    <MobileMenu
                        shouldShowMenu={shouldShowMenu}
                        showMenu={showMenu}
                        handleClick={closeMenu}
                    />
                )}
                <SearchBar />
                <Cart />
            </Wrap>
        );
    }
}

BottomContent.propTypes = {
    className: string,
    isDesktopUser: bool,
    shouldShowMenu: bool,
    toggleMenu: func,
    showMenu: func,
    closeMenu: func,
};

BottomContent.defaultProps = {
    className: '',
    isDesktopUser: false,
    shouldShowMenu: false,
    toggleMenu: () => {},
    showMenu: () => {},
    closeMenu: () => {},
};

export default BottomContent;
